/**
 * Published: what went out and how it moved. Fills once the Metricool connection lands (deferred) and
 * the nightly metrics pull runs; until then the empty state says exactly that.
 */
import { useQuery } from '@tanstack/react-query';
import { PLATFORM_RULES, type Platform } from '@studio/contracts';
import { TopBar } from '@/components/shell';
import { trpc } from '@/lib/trpc';

export function PublishedPage() {
  const queue = useQuery(trpc.posts.queue.queryOptions({ status: 'published' }));
  return (
    <>
      <TopBar title="Published" />
      <section className="content col">
        <div className="card lib-table">
          <table className="tbl">
            <thead><tr><th>Posted</th><th>Platform</th><th>Caption</th><th className="n">Length</th></tr></thead>
            <tbody>
              {queue.data?.posts.map((p) => (
                <tr key={p.id}>
                  <td className="sub mono">{p.slotAt ? new Date(p.slotAt).toLocaleString() : ''}</td>
                  <td><span className="chip">{PLATFORM_RULES[p.platform as Platform]?.label ?? p.platform}</span></td>
                  <td>{p.caption.slice(0, 90)}</td>
                  <td className="n">{p.durationMs ? `${(p.durationMs / 1000).toFixed(0)} s` : ''}</td>
                </tr>
              ))}
              {queue.data?.posts.length === 0 && (
                <tr><td colSpan={4} className="sub creator-empty">Nothing published yet. Posts publish through Metricool, whose connection is deferred until the end of the dev phases; approved posts wait in Scheduled.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}
